import React from "react";
import { Tooltip, Button } from "antd";

const IconButton = ({
  icon,
  text,
  shape,
  title,
  onClick,
  disabled,
  className,
}) => (
  <Tooltip title={title}>
    <Button
      icon={icon}
      type="primary"
      onClick={onClick}
      disabled={disabled}
      className={className}
      shape={shape !== "none" ? shape || "circle" : undefined}
    >
      {text ? <span>{text}</span> : text}
    </Button>
  </Tooltip>
);

export default IconButton;
